<div class="spinner-wrapper">
    <p-progressSpinner></p-progressSpinner>
</div>